import React from 'react';

import { useTheme } from '@material-ui/core';

import logo from '../assets/svg/logo.svg';
import logoWhite from '../assets/svg/logo-white.svg';

interface Props {
  width: number;
  height: number;
}

export const Logo: React.FC<Props> = ({ width, height }) => {
  const theme = useTheme();

  return (
    <img
      width={width}
      height={height}
      alt="logo"
      className="logo-image"
      src={theme.palette.type === 'dark' ? logoWhite : logo}
    />
  );
};
